import styled from 'react-emotion'
import { fontSize } from 'stylist'

const SectionByline = styled.h2`
  text-align: center;
  ${fontSize('l')};
`

export default SectionByline



// WEBPACK FOOTER //
// ./src/routes/home/components/SectionByline.js